// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

export interface MaintenanceModel {
    siteDownForMaintenanceUrl: boolean;
    isDown: boolean;
    downCacheMinutes: number;
}

const maintenanceUrl = "/api/ksc/siteChecker/getEclipseAPIsStatus";

export function getMaintenanceStatus() {
    // Add millisecond to fix api cache issue
    const millisecond = Date.now();
    return get<MaintenanceModel>(`${maintenanceUrl}?${millisecond}`);
}
